module.exports = __webpack_public_path__ + "static/media/logo-conf.5d084ae2.svg";